import ResumeTypes from './types';
import { HostessResumeState, HostessResumeDispatchAction } from './state';
import { Reducer } from 'redux';

export const resumeReducer : Reducer<[HostessResumeState]|null, HostessResumeDispatchAction> = 
    ( state = null, action) => {
        switch(action.type) {
            case ResumeTypes.FETCH_START:
                return state
            case ResumeTypes.FETCH_SUCCESS:
                return action.payload
            default: 
                return state
        }
    }

export default resumeReducer;